// Translation: Login > Landing > Form (Turkish)
export default Object.freeze({
	form: {
		actions: {
			login: {
				label: 'Giriş yap'
			}
		},
		fields: {
			code: {
				placeholder: 'Kodu girin'
			},
			email: {
				placeholder: 'E-postanızı girin'
			},
			password: {
				placeholder: 'Şifrenizi girin'
			}
		},
		options: {
			register: {
				action: 'Kayıt ol',
				label: 'Hesabınız yok mu?'
			},
			reset: {
				action: 'Şifremi unuttum'
			}
		},
		title: {
			credentials: 'Hesap girişi',
			twoFactorAuthentication: 'İki faktörlü kimlik doğrulama'
		}
	}
})
